<script lang="ts">
import { computed } from 'vue';
import type { NavigationNode } from '../../../../types/link';
import Button1XP from '../../../Button1XP/Button1XP.vue';

type Props = {
  items: NavigationNode[];
};
</script>

<script setup lang="ts">
const props = defineProps<Props>();

const visibleItems = computed(() => {
  return props.items.filter((item) => !item.hideInNavigation);
});
</script>

<template>
  <nav :aria-label="items[0]?.label" :class="$style.container">
    <Button1XP
      v-for="item in visibleItems[0]?.children"
      :key="item.id"
      size="s"
      :target="item.newWindow ? '_blank' : '_self'"
      :text="item.label"
      :url="item.url"
      variant="linkStatic"
    />
  </nav>
</template>

<style module lang="scss">
@forward './ExternalLinks.scss';
</style>
